import { render } from "./ArticlesWidget.vue?vue&type=template&id=61195c88"
import script from "./ArticlesWidget.vue?vue&type=script&lang=js"
export * from "./ArticlesWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__